/* Generated by scripts/generate.ts from src/locales. Do not edit by hand. */
import type { NamespaceSchema } from "../catalogue";

export interface DealDetailsCopy {
  tab: {
    activity: string;
    overview: string;
    description: string;
    docs: string;
    documents: string;
    updates: string;
  };
  header: {
    timelineLabel: string;
    returnToTimeline: string;
    deadlineChip: (args: { date: string | number }) => string;
    daysLeft: (args: { days: number }) => string;
    readTime: (args: { minutes: string | number }) => string;
    remindMe: string;
    reminderSet: string;
    keyFactsHeading: string;
    dealNotFound: string;
    identityTerm: (args: { months: number }) => string;
    identityTermVariable: (args: { months: number }) => string;
  };
  earn: {
    heading: string;
    calculateTop: string;
    calculateBottom: string;
    ifIsaTop: string;
    ifIsaBottom: string;
  };
  cta: {
    investNow: string;
    investNowBestRate: (args: { rate: string | number }) => string;
    investNowRate: (args: { rate: string | number }) => string;
    investSecondary: string;
    continueOnboarding: string;
    investClosed: string;
  };
  chat: {
    pillLabel: string;
    promptQuestion: (args: { dealName: string | number }) => string;
    promptCta: (args: { isFund: string | number }) => string;
    askAiBot: string;
  };
  section: {
    returns: string;
    noticePeriods: string;
    redemption: string;
    riskStructure: string;
    fundEntities: string;
    investorWebinar: string;
    documents: string;
    timeline: string;
  };
  row: {
    targetRate: string;
    distribution: string;
    exitRate: string;
    rateLock: string;
    postLockChange: string;
    maturity: string;
    notice: (args: { months: string | number }) => string;
    minimumNotice: (args: { months: number }) => string;
    nextCutOff: string;
    cutOffDates: string;
    noticeStartsFrom: string;
    coolingOff: string;
    sriRating: string;
    leverage: string;
    capitalProtection: string;
    riskProfile: string;
    ukTaxBenefits: string;
    shariaCompliant: string;
    managementFee: string;
    capitalReturnedBy: string;
    custodian: string;
    minimumInvestment: string;
    maximumInvestment: string;
    entryExitFee: string;
    opens: string;
    deadline: string;
    firstDistribution: string;
  };
  value: {
    yes: string;
    shariaCertifiedPill: string;
    noFee: string;
    netOfFeeNote: (args: { fee: string | number }) => string;
    memberUpliftNote: (args: { uplift: string | number; memberRate: string | number }) => string;
    boosterNote: (args: { booster: string | number }) => string;
    escrowProvider: (args: { provider: string | number }) => string;
    redemptionNoticeStartsFrom: string;
    redemptionCoolingOff: string;
    rateLockPeriod: string;
    postLockChange: string;
    fallbackRedemptionCutOffs: string;
  };
  sharia: {
    seeMore: string;
    cardTitle: string;
    cardCta: string;
  };
  calculator: {
    title: string;
    body: string;
    cta: string;
  };
  ifIsaCard: {
    title: string;
    body: string;
    cta: string;
  };
  capacity: {
    limitLabel: (args: { cap: string | number }) => string;
    remainingLabel: (args: { remaining: string | number }) => string;
    closedTitle: string;
    closedBody: string;
  };
  openingSoon: {
    title: string;
    opensLabel: string;
    closesLabel: string;
  };
  description: {
    overviewLabel: string;
    empty: string;
  };
  webinar: {
    replayCta: string;
    recordedOn: (args: { date: string | number }) => string;
    dealOverviewTitle: string;
    investorCallTitle: string;
  };
  docs: {
    countPill: (args: { count: number }) => string;
    typeLabel: string;
    filterAll: string;
    categoryLegal: string;
    categorySharia: string;
    investorHeading: string;
    statementTitle: string;
    statementMeta: string;
    emptyTitle: string;
    emptyBody: string;
    empty: string;
  };
  updates: {
    intro: (args: { fundName: string | number }) => string;
    myInvestments: string;
    allDeals: string;
    heading: string;
    empty: string;
  };
}

export const dealDetailsSchema: NamespaceSchema = {
  namespace: "deal-details",
  keys: {
    "tab.activity": [],
    "tab.overview": [],
    "tab.description": [],
    "tab.docs": [],
    "tab.documents": [],
    "tab.updates": [],
    "header.timelineLabel": [],
    "header.returnToTimeline": [],
    "header.deadlineChip": ["date"],
    "header.daysLeft": ["days"],
    "header.readTime": ["minutes"],
    "header.remindMe": [],
    "header.reminderSet": [],
    "header.keyFactsHeading": [],
    "header.dealNotFound": [],
    "header.identityTerm": ["months"],
    "header.identityTermVariable": ["months"],
    "earn.heading": [],
    "earn.calculateTop": [],
    "earn.calculateBottom": [],
    "earn.ifIsaTop": [],
    "earn.ifIsaBottom": [],
    "cta.investNow": [],
    "cta.investNowBestRate": ["rate"],
    "cta.investNowRate": ["rate"],
    "cta.investSecondary": [],
    "cta.continueOnboarding": [],
    "cta.investClosed": [],
    "chat.pillLabel": [],
    "chat.promptQuestion": ["dealName"],
    "chat.promptCta": ["isFund"],
    "chat.askAiBot": [],
    "section.returns": [],
    "section.noticePeriods": [],
    "section.redemption": [],
    "section.riskStructure": [],
    "section.fundEntities": [],
    "section.investorWebinar": [],
    "section.documents": [],
    "section.timeline": [],
    "row.targetRate": [],
    "row.distribution": [],
    "row.exitRate": [],
    "row.rateLock": [],
    "row.postLockChange": [],
    "row.maturity": [],
    "row.notice": ["months"],
    "row.minimumNotice": ["months"],
    "row.nextCutOff": [],
    "row.cutOffDates": [],
    "row.noticeStartsFrom": [],
    "row.coolingOff": [],
    "row.sriRating": [],
    "row.leverage": [],
    "row.capitalProtection": [],
    "row.riskProfile": [],
    "row.ukTaxBenefits": [],
    "row.shariaCompliant": [],
    "row.managementFee": [],
    "row.capitalReturnedBy": [],
    "row.custodian": [],
    "row.minimumInvestment": [],
    "row.maximumInvestment": [],
    "row.entryExitFee": [],
    "row.opens": [],
    "row.deadline": [],
    "row.firstDistribution": [],
    "value.yes": [],
    "value.shariaCertifiedPill": [],
    "value.noFee": [],
    "value.netOfFeeNote": ["fee"],
    "value.memberUpliftNote": ["uplift", "memberRate"],
    "value.boosterNote": ["booster"],
    "value.escrowProvider": ["provider"],
    "value.redemptionNoticeStartsFrom": [],
    "value.redemptionCoolingOff": [],
    "value.rateLockPeriod": [],
    "value.postLockChange": [],
    "value.fallbackRedemptionCutOffs": [],
    "sharia.seeMore": [],
    "sharia.cardTitle": [],
    "sharia.cardCta": [],
    "calculator.title": [],
    "calculator.body": [],
    "calculator.cta": [],
    "ifIsaCard.title": [],
    "ifIsaCard.body": [],
    "ifIsaCard.cta": [],
    "capacity.limitLabel": ["cap"],
    "capacity.remainingLabel": ["remaining"],
    "capacity.closedTitle": [],
    "capacity.closedBody": [],
    "openingSoon.title": [],
    "openingSoon.opensLabel": [],
    "openingSoon.closesLabel": [],
    "description.overviewLabel": [],
    "description.empty": [],
    "webinar.replayCta": [],
    "webinar.recordedOn": ["date"],
    "webinar.dealOverviewTitle": [],
    "webinar.investorCallTitle": [],
    "docs.countPill": ["count"],
    "docs.typeLabel": [],
    "docs.filterAll": [],
    "docs.categoryLegal": [],
    "docs.categorySharia": [],
    "docs.investorHeading": [],
    "docs.statementTitle": [],
    "docs.statementMeta": [],
    "docs.emptyTitle": [],
    "docs.emptyBody": [],
    "docs.empty": [],
    "updates.intro": ["fundName"],
    "updates.myInvestments": [],
    "updates.allDeals": [],
    "updates.heading": [],
    "updates.empty": [],
  },
};
